import ExamRoutes from './examRoutes';

export default function PdfRoutes() {
  return (
    <div className="bg-light">
      {ExamRoutes}
    </div>
  )
}